let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fcy2e")).then(() => parcelRequire('3Wujw'));